<template>
  <q-dialog :model-value="modelValue" persistent @update:model-value="$emit('update:modelValue', $event)">
    <q-card style="width: 600px; max-width: 90vw;">
      <q-card-section>
        <div class="text-h6">
          <q-icon name="call_split" color="orange" class="q-mr-sm" />
          Disassemble Compound {{ item?.type === 'device' ? 'Device' : 'Equipment' }}
        </div>
      </q-card-section>

      <q-card-section v-if="item">
        <div class="q-mb-md">
          <div class="text-subtitle2">{{ item?.type === 'device' ? 'Device' : 'Equipment' }} to Disassemble:</div>
          <div class="text-body1 text-weight-bold">{{ item.label || item.name }}</div>
        </div>

        <q-card flat bordered class="q-mb-md">
          <q-card-section>
            <div class="text-subtitle2 q-mb-sm">Current Components:</div>
            <q-list dense separator>
              <q-item v-for="component in components" :key="component.id">
                <q-item-section avatar>
                  <q-icon :name="component.icon || 'precision_manufacturing'" />
                </q-item-section>
                <q-item-section>
                  <q-item-label>{{ component.name }}</q-item-label>
                  <q-item-label caption>{{ component.brick_class }}</q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </q-card-section>
        </q-card>

        <q-card flat bordered class="bg-warning-1 q-pa-sm">
          <div class="text-caption">
            <q-icon name="warning" color="warning" />
            This will separate the compound equipment back into individual components.
            All relationships will be preserved as standalone equipment relationships.
          </div>
        </q-card>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="Cancel" @click="$emit('update:modelValue', false)" />
        <q-btn
          color="orange"
          label="Disassemble"
          icon="call_split"
          :loading="loading"
          @click="$emit('confirm')"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script setup>
  import { defineProps, defineEmits } from 'vue';

  const props = defineProps({
    modelValue: { type: Boolean, required: true },
    item: { type: Object, default: null },
    components: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  });

  const emit = defineEmits(['update:modelValue', 'confirm']);
</script>
